import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const teamService = {
  _url: process.env.REACT_APP_TEAM_API_URL,
  _platform_id: 'feedalabs',
  _domain_id: '3f52595c-3cc9-448e-8f8f-8536ef7e8b66',

  GetTeamList(searchQuery, fetch) {
    const [data, setsData] = useState({
      teams: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllTeam(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },
  GetFilteredTeamList(searchQuery, fetch) {
    const [data, setsData] = useState({
      teams: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getFilteredTeamList(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async getAllTeam(searchQuery) {
    const params = new URLSearchParams({
      team_type: 'user_created',
      // platform_id: this._platform_id,
      domain_id: this._domain_id,
    });
    if (searchQuery && typeof searchQuery === 'string') {
      params.set('user_id', searchQuery);
    }
    return await Fetch.get(`${this._url}/list?${params.toString()}`);
  },

  async getTeamDetails(id) {
    const params = new URLSearchParams({
      team_id: id,
      platform_id: this._platform_id,
    });
    return await Fetch.get(`${this._url}/details?${params.toString()}`);
  },

  async getFilteredTeamList(searchQuery) {
    const params = new URLSearchParams({
      team_type: searchQuery?.team_type || 'admin_created',
      // platform_id: searchQuery?.platform_id || this._platform_id,
      domain_id: searchQuery?.domain_id || this._domain_id,
    });
    return await Fetch.get(`${this._url}/list?${params.toString()}`);
  },

  async createTeam(payload) {
    return await Fetch.post(`${this._url}/create`, {
      ...payload,
      platform_id: payload.platform_id || this._platform_id,
      domain_id: payload.domain_id || this._domain_id,
    });
  },

  async updateTeam(payload) {
    return await Fetch.put(`${this._url}/update`, {
      ...payload,
      platform_id: payload.platform_id || this._platform_id,
      domain_id: payload.domain_id || this._domain_id,
    });
  },

  async deleteTeam(id) {
    const params = new URLSearchParams({
      team_id: id,
      platform_id: this._platform_id,
    });
    return await Fetch.delete(`${this._url}/delete?${params.toString()}`);
  },
};

export default teamService;
